import { useUiFromSpecContext } from '../../../EditorContextProvider.js'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import DefaultEditTabElement from '../EditInputFields/DefaultEditTabElement.js'

export default function OtherEditElement({
  form,
  keyTab,
  currentElementState,
  setCurrentElementState,
}: Readonly<{
  form: UseFormReturn<any>
  keyTab: string,
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}>) {
  const { customEditElement } = useUiFromSpecContext()
  const generalCurrentElementState = useMemo(() => {
    if (!currentElementState) return null
    const { logic, constraints, ...rest } = currentElementState.edit_tabs[keyTab] ?? currentElementState
    return rest
  }, [currentElementState])

  return (
    <>
      {generalCurrentElementState &&
        Object.keys(generalCurrentElementState).map((element, index) => {
          if (customEditElement) {
            return customEditElement({
              element,
              index,
              currentElementState,
              setCurrentElementState,
              defaultEditElementProps: (
                <DefaultEditTabElement
                  key={index}
                  index={index}
                  form={form}
                  element={element}
                  keyTab={keyTab}
                  currentElementState={currentElementState}
                  setCurrentElementState={setCurrentElementState}
                />
              ),
            })
          }

          return (
            <DefaultEditTabElement
              key={index}
              index={index}
              form={form}
              element={element}
              keyTab={keyTab}
              currentElementState={currentElementState}
              setCurrentElementState={setCurrentElementState}
            />
          )
        })}
    </>
  )
}
